import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ProductAddToBasketComponentDef } from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { BundleSelection } from '@df/catalog/product/bundle-selection';
import { IProductDataV2 } from '@df/catalog/product/product';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { TranslationService } from '@df/ui/translation/translation.service';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ItemQtyComponent } from 'projects/app-default/src/app/basket/item-qty.component';
import { XnotifFormComponent } from 'projects/app-default/src/app/module/xnotif/xnotif-form.component';
import { IfNotTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-not-trade-store.directive';
import { IfTradeStoreDirective } from 'projects/app-default/src/app/multisite/trade/if-trade-store.directive';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { LabelPaneComponent } from 'projects/app-default/src/app/ui/display/label-pane/label-pane.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { BottomPanelComponent } from 'projects/app-default/src/app/ui/widget/bottom-panel/bottom-panel.component';
import { LocalProduct } from '../../../../model/product/product.decorator';
import { ProductViewWishlistToggleComponent } from '../../product-view-wishlist-toggle/product-view-wishlist-toggle.component';
import { NProductBundleOptions } from '../modal/product-bundle-options-modal.interface';

@Component({
    selector: 'product-bundle-options-create-set',
    templateUrl: './product-bundle-options-create-set.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        BottomPanelComponent,
        DfUiModule,
        ICmsClientModule,
        IfNotTradeStoreDirective,
        IfTradeStoreDirective,
        ItemQtyComponent,
        LabelPaneComponent,
        NgTemplateOutlet,
        ProductViewWishlistToggleComponent,
        ResultComponent,
        TranslationModule,
        XnotifFormComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBundleOptionsCreateSetComponent extends ProductAddToBasketComponentDef {
    @Input()
    override product?: LocalProduct<IProductDataV2> | undefined;
    @Input()
    bundleSelection?: BundleSelection;
    readonly bundleModalId = NProductBundleOptions.MODAL_ID;

    translationService = inject(TranslationService);

    get warning(): string | undefined {
        if (this.maxQty > 0 && (!this.isSalable || this.maxQty < 6)) {
            return this.translationService.transform('Only % left in stock', this.maxQty);
        }
        return undefined;
    }
}
